import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AccountsFacade } from '@personal-area/global/accounts/services';
import { CreatedAccount, ServerType } from '@personal-area/global/accounts/models';
import { BreadcrumbsComponent } from '@personal-area/global/navigation-layout';

import { AccountTariffsModule } from '../../components/account-tariffs/account-tariffs.module';

@Component({
    templateUrl: './tariff-setup.component.html',
    styleUrls: ['./tariff-setup.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AccountTariffsModule, BreadcrumbsComponent]
})
export class TariffSetupComponent {
  public selectedServer: ServerType;

  constructor(
    private readonly _router: Router,
    private readonly _accountsFacade: AccountsFacade,
    route: ActivatedRoute,
  ) {
    this.selectedServer = route.snapshot.queryParams['selectedServer'] as ServerType;
  }

  public async goToDashboard({ id }: CreatedAccount): Promise<void> {
    this._accountsFacade.select(id);
    this._accountsFacade.selectPrimary(id);
    this._accountsFacade.getAccount(id);

    await this._router.navigate(['/dashboard/']);
  }
}
